import { apiRequest } from './auth';

export const positionsAPI = {
  getAll: async () => {
    return await apiRequest('/positions');
  },

  getByProject: async (project) => {
    return await apiRequest(`/positions/${encodeURIComponent(project)}`);
  },

  add: async (project, positionName) => {
    return await apiRequest(`/positions/${encodeURIComponent(project)}`, {
      method: 'POST',
      body: JSON.stringify({ positionName }),
    });
  },

  remove: async (project, positionName) => {
    return await apiRequest(`/positions/${encodeURIComponent(project)}/${encodeURIComponent(positionName)}`, {
      method: 'DELETE',
    });
  }
};

export default positionsAPI;
